// extracted by mini-css-extract-plugin
module.exports = {"dropdownSelector":"styles_dropdownSelector___OLQR","selected":"styles_selected__9BzXz"};